(function (){
    'use strict';

    angular
        .module('services')
        .service('InvoicesService', InvoicesService);

    InvoicesService.$inject = ['$http', 'API_BASE'];

    function InvoicesService($http, API_BASE) {

        var service = this;

        // service.get         = get;
        service.getInvoiceTypes         = getInvoiceTypes;
        service.getInvoicesForOverview  = getInvoicesForOverview;

        service.getAll                              = getAll;
        service.getByFilter                         = getByFilter;
        service.downloadCSV                         = downloadCSV;
        service.getUserInvoices                     = getUserInvoices;
        service.getInvoiceItems                     = getInvoiceItems;
        service.setData                             = setData;
        service.getData                             = getData;
        service.store                               = store;
        service.validate                            = validate;
        service.validateItem                        = validateItem;
        service.getURL                              = getURL;
        service.destroy                             = destroy;
        service.getClientsByFilter                  = getClientsByFilter;
        service.storeClient                         = storeClient;
        service.getInvoicesByFilter                 = getInvoicesByFilter;
        service.sendInvoiceToCustomer               = sendInvoiceToCustomer;
        service.sendInvoiceToSeller                 = sendInvoiceToSeller;
        service.validateCustomer                    = validateCustomer;
        service.qboSync                             = qboSync;
        service.getInvoicesPayment                  = getInvoicesPayment;
        service.getInvoicesCostCenterCategory       = getInvoicesCostCenterCategory;
        service.getInvoicesCostCenterSubcategory    = getInvoicesCostCenterSubcategory;
        service.getInvoicePaymentHistory            = getInvoicePaymentHistory;
        service.getBanks                            = getBanks;
        service.getPaymentsMethods                  = getPaymentsMethods;
        service.getInvoicesAccount                  = getInvoicesAccount;
        service.getInvoicesBankAccount              = getInvoicesBankAccount;
        service.saveInvoicePayment                  = saveInvoicePayment;
        service.getCurrencies                       = getCurrencies;
        service.getPaymentCurrencies                = getPaymentCurrencies;
        service.deleteInvoicePayment                = deleteInvoicePayment;
        service.authorizeInvoicePayment             = authorizeInvoicePayment;
        service.unauthorizeInvoicePayment           = unauthorizeInvoicePayment;
        service.getInvoicePaymentItems              = getInvoicePaymentItems;
        service.getInvoicesCostCenters              = getInvoicesCostCenters;
        service.getPayees                           = getPayees;
        service.getInvoiceById                      = getInvoiceById;
        service.editInvoicePayment                  = editInvoicePayment;
        service.create_admin_commissions            = create_admin_commissions;
        service.create_vf_commissions               = create_vf_commissions;
        service.create_pr_commissions               = create_pr_commissions;
        service.getInvoiceByControlID               = getInvoiceByControlID;
        service.updateInvoice                       = updateInvoice;
        service.getLastInvoice                      = getLastInvoice;
        service.updateAddress                       = updateAddress;

        service.flash;

        service.data;

        function getAll(type = 'expo') {
            var filters = {};
            filters[type + '_id'] = 'active';
            return $http.get(API_BASE + '/invoice/' + type, {params: filters});
        }
        function getByFilter(filters, type = 'expo') {
            return $http.get(API_BASE + '/invoice/' + type, {params: filters});
        }
        function downloadCSV(filters, type = 'expo') {
            return $http.get(API_BASE + '/invoice/' + type + '/csv', {params: filters});
        }
        function getUserInvoices(user_id, filters, type = 'expo') {
            return $http.get(API_BASE + '/invoice/' + type + '/user/' + user_id + '/invoices', {params: filters});
        }
        function getInvoiceItems(user_id, currency, filters, type = 'expo') {
            if (type != 'general') {
                var result = $http.get(API_BASE + '/invoice/' + type + '/user/' + user_id + '/currency/' + currency + '/create', {params: filters});
            } else {
                var result = $http.get(API_BASE + '/invoice/' + type + '/user/' + user_id + '/create', {params: filters});
            }
            return result;
        }

        function validate(data) {
            return $http.post(API_BASE + '/invoice/validate', data)
                .then(function(response) {
                    return response.data;
                });
        }

        function validateItem(data) {
            return $http.post(API_BASE + '/invoice/validate-item', data)
                .then(function(response) {
                    return response.data;
                });
        }

        function validateCustomer(data) {
            return $http.post(API_BASE + '/invoice/validate-customer', data)
                .then(function(response) {
                    return response.data;
                });
        }

        function setData(data) {
            service.data = data;
        }

        function getData() {
            return service.data;
        }

        function getURL(invoice_id, type) {
            return $http.get(API_BASE + '/invoice/' + invoice_id + '/type/' + type + '/url');
        }

        function store(data) {
            return $http.post(API_BASE + '/invoice', data)
                .then(function(response) {
                    return response.data;
                });
        }

        function destroy(invoice_id) {
            return $http.delete(API_BASE + '/invoice/' + invoice_id);
        }

        function getClientsByFilter(filters) {
            return $http.get(API_BASE + '/invoice/general', {params: filters});
        }

        function storeClient(data) {
            return $http.post(API_BASE + '/invoice/customer', data)
                .then(function(response) {
                    return response.data;
                });
        }

        function getInvoicesByFilter(filters) {
            return $http.get(API_BASE + '/invoice/search', {params: filters});
        }

        function sendInvoiceToCustomer(invoice_id) {
            return $http.get(API_BASE + '/invoice/' + invoice_id + '/send_to_customer');
        }

        function sendInvoiceToSeller(invoice_id) {
            return $http.get(API_BASE + '/invoice/' + invoice_id + '/send_to_seller');
        }

        function qboSync(invoice_id) {
            return $http.get(API_BASE + '/invoice/' + invoice_id + '/qbosync');
        }

        function getInvoiceTypes(invoice_id) {
            return $http.get(API_BASE + '/invoice/types');
        }

        function getInvoicesForOverview(data) {
            return $http.get(API_BASE + '/invoice/overview',{params : data});
        }

        function getInvoicesPayment() {
            return $http.get(API_BASE + '/invoice/invoices_payments/list');
        }

        function getInvoicesCostCenterCategory() {
            return $http.get(API_BASE + '/invoice/cost_center_category/list');
        }

        function getInvoicesAccount() {
            return $http.get(API_BASE + '/invoice/invoices_account/list');
        }

        function getInvoicesBankAccount() {
            return $http.get(API_BASE + '/invoice/invoices_bank_account/list');
        }

        function getInvoicesCostCenterSubcategory(category_id) {
            return $http.get(API_BASE + '/invoice/cost_center_subcategory/' + category_id + '/list');
        }

        function getInvoicePaymentHistory(invoice_id) {
            return $http.get(API_BASE + '/invoice/invoice_payment_history/' + invoice_id + '/list');
        }

        function getBanks() {
            return $http.get(API_BASE + '/invoice/banks/list');
        }

        function getPaymentsMethods() {
            return $http.get(API_BASE + '/invoice/payments_method/list');
        }

        function saveInvoicePayment(data) {
            return $http.post(API_BASE + '/invoice/payments_method/save', data);
        }

        function getCurrencies() {
            return $http.get(API_BASE + '/currencies/list');
        }

        function getPaymentCurrencies() {
            return $http.get(API_BASE + '/currencies/payment/list');
        }

        function deleteInvoicePayment(query) {
            return $http.post(API_BASE + '/invoice/invoices_payments/delete', query);
        }

        function getInvoicePaymentItems(invoice_id) {
            return $http.get(API_BASE + '/invoice/invoices_payments/list_invoice_items/'+invoice_id);
        }

        function authorizeInvoicePayment(query) {
            return $http.get(API_BASE + '/invoice/payment_authorize/',{params:query});
        }

        function unauthorizeInvoicePayment(query) {
            return $http.get(API_BASE + '/invoice/payment_unauthorize/',{params:query});
        }

        function getInvoicesCostCenters()
        {
            return $http.get(API_BASE + '/cost_centers/all');
        }

        function getPayees()
        {
            return $http.get(API_BASE + '/payees/select');
        }

        function getInvoiceById(query) {
            return $http.get(API_BASE + '/invoice/get_invoice/',{params:query});
        }

        function editInvoicePayment(query) {
            return $http.put(API_BASE + '/invoice/invoice_payment/edit/',query);
        }

        function create_admin_commissions() {
            return $http.get(API_BASE + '/invoice/admin_commissions');
        }

        function create_vf_commissions(seller_id, from) {
            return $http.get(API_BASE + 'invoice/virtual_fair/commissions/create/' + seller_id + '/' + from);
        }

        function create_pr_commissions(seller_id, from) {
            return $http.get(API_BASE + 'invoice/platform_rental/commissions/create/' + seller_id + '/' + from);
        }

        function getInvoiceByControlID(control_id) {
            return $http.get(API_BASE + '/invoice/get_by_control_id/' + control_id);
        }

        function updateInvoice(control_id, query) {
            return $http.put(API_BASE + '/invoice/update/' + control_id, query);
        }

        function getLastInvoice(customer_id) {
            return $http.get(API_BASE + '/invoice/user/' + customer_id + '/last');
        }

        function updateAddress(id, data) {
            return $http.put(API_BASE + '/invoice/' + id + '/address', data);
        }

    }
})();
